import React from "react";
import "containers/Template/Footer/Footer.css";
import AxiosConfig from "../../../axiosConfig";
import FooterSection from "./FooterSections";
import CustomA from "../../../components/General/Text/customA";

class Footer extends React.Component {

	constructor(props) {
        super(props);
        this.state = {
            discover: [],
            ourCompany: [],
            letsConnect: [],
        };
    }

	componentDidMount() {
		AxiosConfig.get(`misc/footer/`)
			.then((res) => {
				if ("Discover" in res.data)
				{
						this.setState({
						discover: res.data["Discover"],
					});
				}

				if ("Our Company" in res.data)
				{
						this.setState({
						ourCompany: res.data["Our Company"],
					});
				}

				if ("Let's Connect" in res.data)
				{
						this.setState({
						letsConnect: res.data["Let's Connect"],
					});
				}
			})
			.catch();
	}

	render() {
		return (
      <div className="main_container">
        <div className="footer_container">
          <FooterSection title="DISCOVER" content={this.state.discover} />
          <FooterSection title="OUR COMPANY" content={this.state.ourCompany} />
          <FooterSection
            title="LET'S CONNECT"
            content={this.state.letsConnect}
          />
        </div>

        <div className="allrights">
          ALL RIGHTS RESERVED. {"Copyright © "} {new Date().getFullYear()} Babee
          Play Co. dba Katamundi.
          <br />
          Before accessing this site, you must agree to our{" "}
          <CustomA href="/terms-and-conditions" target="_blank">
            Terms of Use
          </CustomA>{" "}
          and{" "}
          <CustomA href="/security-and-privacy" target="_blank">
            Privacy Policy
          </CustomA>
          . Please read them.
        </div>
      </div>
    );
	}
}

export default Footer;